export default __webpack_public_path__ + "static/media/canchapadel1.bd73cb0d.png";